(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-smx-page]').forEach(page => {
      const content = page.querySelector('[data-smx-content]');
      const navigation = page.querySelector('[data-smx-toc]');
      const list = navigation?.querySelector('ul');
      if (!content || !navigation || !list || navigation.dataset.initialized || navigation.dataset.disabled === 'true') return;
      let headings = [...content.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
      if (headings.length < 2) headings = [...content.querySelectorAll('h2,h3')].filter(heading => heading.textContent.trim());
      if (headings.length < 2) headings = [...content.querySelectorAll('p > strong:only-child')]
        .filter(heading => /^§\s*\d+\b/.test(heading.textContent.trim()) && heading.textContent.trim() === heading.parentElement.textContent.trim())
        .map(heading => heading.parentElement);
      if (headings.length < 2) return;
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `smx-page-heading-${index + 1}-${page.dataset.smxPage}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        fragment.append(item);
      });
      list.replaceChildren(fragment);
      navigation.hidden = false;
      navigation.dataset.initialized = 'true';
      const disclosure = navigation.querySelector('details');
      if (disclosure) disclosure.open = window.matchMedia('(min-width: 1024px)').matches || navigation.dataset.openMobile === 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
